<script>
import formatCurrency from "@utils/format-currency";
import { authComputed, merchantComputed } from "@store/helpers";
import formatPrice, { formatPriceRange } from "@utils/format-price";
import { memberLevelPriceDiscount } from "@utils/ipetbooking-level";

export default {
  props: {
    depositItem: {
      type: Object,
      default: () => {
        return {
          "uuid": "b94a8ab6-c2fd-470f-8edd-8254029341de",
          "title": "1",
          "description": null,
          "point": 2,
          "price": 1,
          "keepTop": 0,
          "mode": "selling",
          "state": 1,
          "canBuy": true
        }
      }
    },
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    billList() {
      return [
        {
          title: `1${this.$globalIsDingBeauty ? '<i class="fontello fontello-db-lipstick fa-fw ml-2 text-primary"></i>': '<i class="fontello fontello-paw fa-fw ml-2 text-primary-dark"></i>'}`,
          text: `${
                this.depositItem.levelDiscount > 0 ?  
                `<span class=""> 
                  會員價：NT$ ${memberLevelPriceDiscount(this.depositItem.price, this.depositItem)}
                </span>
                <br>
                <span class="font-number text-decoration-line-through fs-2sm text-gray-2">售價：NT$ ${this.depositItem.price}</span>
                `
                : 
                this.depositItem.price || 0
              }`,
          textClass: 'font-number'
        },
        {
          type: 'hr'
        },
        {
          title: '總計', 
          text: `${formatPrice(this.depositItem.levelDiscount > 0 ? memberLevelPriceDiscount(this.depositItem.price, this.depositItem) : this.depositItem.price) || 0}`,
          class: 'align-items-end',
          textClass: this.$globalIsDingBeauty ? 'font-number fw-semi-bold fs-xl text-secondary' : 'text-primary-dark font-number fw-semi-bold fs-xl',
        },
      ]
    },
  },
  methods: {
    formatPrice,
    formatPriceRange,
    memberLevelPriceDiscount,
    onSubmit() {
      const depositUuid = this.depositItem.uuid

      const loggedInFn = () => {
        this.$nextTick(() => {
          if(this.isBlock) {
            this.$globalDialog('DialogBlock', {})
            return
          }
          const loadingMaskCheckOutCart = this.$loading({
            lock: true,
            text: '正在前往結帳',
            spinner: `fal fa-circle-notch fa-spin`,
            background: 'rgba(81, 176, 202, 0.3)',
            customClass: 'isStyleCheckout'
          });
          this.loadingStoreCart = true;

          this.tryToStoreCart({ depositUuid })
            .then(() => {
              const goToDepositCheckout = () => {
                this.$router.push({
                  name: 'deposit-checkout',
                  params: {
                    depositUuid
                  }
                });
              };

              goToDepositCheckout()
            })
            .catch((e) => {
              if(e.status === 'STATUS_CODE_UNDEFINED') {
                this.$globalDialog('DialogBlock', {})
              }
            })
            .finally(() => {
              this.loadingStoreCart = false;
              loadingMaskCheckOutCart.close()
            })
        });
      };

      if(this.isLoggedIn) {
        loggedInFn()
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            loggedInFn()
          }
        })
      }
    },
    async tryToStoreCart({ depositUuid }) {
      if(this.$isLoading('storeCart')) {
        return false;
      }

      await this.$store.dispatch('cart/storeCart', {
        depositUuid,
      })
        .then(() => {
          return true
        })
    },
  }
}
</script>
<!-- section template -->
<template>
  <div v-if="depositItem.uuid" :class="[$style.infoBoxJtails, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
    <div class="infoBoxJtails__title">
      {{ depositItem.title }}
    </div>
    <div class="infoBoxJtails__info">
      <div>
        <i v-if="$globalIsDingBeauty" class="fontello fontello-db-lipstick fa-fw mr-2 text-primary"></i>
        <i v-else class="fontello fontello-db-lipstick fa-fw mr-2 text-gray-3"></i>
        <span>
          <span>{{depositItem.point}}點</span>
        </span>
      </div>
    </div>
    <div class="mb-4 d-none d-md-block">
      <BaseList
        :data-list="billList"
        type="bill"
      />
    </div>
    <div class="infoBoxJtails__mobile-info">
      <div class="infoBoxJtails__mobile-info__inner">
        <div class="infoBoxJtails__mobile-info__left">
          <span class="infoBoxJtails__mobile-info__title">
            <span class="font-number fw-medium">
                <template v-if="depositItem.levelDiscount > 0">
                  {{ formatPrice(memberLevelPriceDiscount(depositItem.price, depositItem)) }}
                  <span class="font-number text-decoration-line-through fs-2sm text-gray-2">NT$ {{ depositItem.price }}</span>
                </template>
                <template v-else>
                  {{ formatPrice(depositItem.price) }}
                </template>
            </span>
          </span>
        </div>
        <template v-if="!currentMerchant.depositSetting.isEnabled">
          <BaseButton
            class="isStyleSecondary isFull"
            :class="{
              'isRadius': $globalIsJtails,
            }"
            disabled
          >
            尚未開放預約
          </BaseButton>
        </template>
        <BaseButton
          v-else
          :loading="$isLoading('storeCart')"
          class="isStylePrimary isFull"
          :class="{
            'isRadius': $globalIsJtails,
          }"
          @click="onSubmit"
        >
          立即購買
        </BaseButton>
      </div>
    </div>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.infoBoxJtails {
  padding: 2.25rem 1.875rem;
  background: #FFF;
  box-shadow: 2px 8px 36px #1C2C5414;

  @include max-md {
    padding: 0.75rem $container-gap;
    padding-bottom: 0.75rem;
    padding-bottom: calc(0.75rem + constant(safe-area-inset-bottom));
    padding-bottom: calc(0.75rem + env(safe-area-inset-bottom));
    border-radius: 0;
    box-shadow: 0 -1px 4px #1C2C5414;
  }

  :global {
    .infoBoxJtails {
      &__title {
        margin-bottom: 1rem;
        font-size: 1.25rem;
        font-weight: 600;

        @extend %FontSerifWeightJtails;

        @include max-md {
          display: none;
        }
      }

      &__info {
        margin-bottom: 2rem;
        font-size: 0.875rem;
        line-height: 2;
        color: $color-gray-2;

        @include max-md {
          display: none;
        }
      }

      &__mobile-info {
        &__inner {
          @include max-md {
            display: flex;
            justify-content: space-between;
          }
        }

        &__left {
          @include min-md {
            display: none;
          }
        }

        &__title {
          display: block;
          font-size: 1.1rem;
          line-height: 1;
        }

        .baseButton {
          @include max-md {
            width: auto;
            padding: 0.4rem 1.5rem;
            font-size: 0.875rem;
          }
        }
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .fontello-db-lipstick {
        font-size: 1rem;
        position: relative;
        left: -2px;
      }
    }
  }
}
</style>
